"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.styledComponentConfig = exports.headlineSizesV3 = exports.componentConfig = exports.backgrounds = void 0;
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var backgrounds = exports.backgrounds = ['brandLight', 'grey', 'white', 'whiteWithBorder'];

// Custom headline sizes for Image Hero V3 = xsmall, small, medium, large for different viewports xxs (mobile), m (tablet), l (desktop)
var headlineSizesV3 = exports.headlineSizesV3 = {
  xsmall: {
    // Viewport sizes
    xxs: '2',
    m: '2',
    l: '4'
  },
  small: {
    // Viewport sizes
    xxs: '3',
    m: '3',
    l: '6'
  },
  medium: {
    // Viewport sizes
    xxs: '4',
    m: '4',
    l: '8'
  },
  large: {
    // Viewport sizes
    xxs: '5',
    m: '5',
    l: '10'
  }
};
var variants = exports.variants = {
  v2: 'v2',
  v3: 'v3'
};
var componentConfig = exports.componentConfig = {
  typography: {
    size: {
      headline: {
        xxs: _defineProperty(_defineProperty({}, variants.v2, '2'), variants.v3, '2'),
        m: _defineProperty(_defineProperty({}, variants.v2, '4'), variants.v3, '2'),
        l: _defineProperty(_defineProperty({}, variants.v2, '8'), variants.v3, '10')
      },
      subHeadline: {
        xxs: _defineProperty(_defineProperty({}, variants.v2, 'm1'), variants.v3, 'm1'),
        m: _defineProperty(_defineProperty({}, variants.v2, '1'), variants.v3, 'm1'),
        l: _defineProperty(_defineProperty({}, variants.v2, '4'), variants.v3, '2')
      },
      description: {
        xxs: _defineProperty(_defineProperty({}, variants.v2, 'm1'), variants.v3, 'm1'),
        l: _defineProperty(_defineProperty({}, variants.v2, '2'), variants.v3, '1')
      },
      representative: {
        xxs: _defineProperty(_defineProperty({}, variants.v2, 'm1'), variants.v3, '2'),
        m: _defineProperty(_defineProperty({}, variants.v2, 'm1'), variants.v3, '2'),
        l: _defineProperty(_defineProperty({}, variants.v2, '3'), variants.v3, '4')
      },
      terms: {
        xxs: _defineProperty(_defineProperty({}, variants.v2, 'm2'), variants.v3, 'm2')
      }
    },
    type: {
      headline: 'display',
      subHeadline: 'heading',
      description: 'paragraph',
      representative: 'heading',
      terms: 'paragraph'
    }
  }
};
var styledComponentConfig = exports.styledComponentConfig = {
  contentWrapper: {
    gap: {
      xxs: _defineProperty(_defineProperty({}, variants.v2, 'var(--spacing-global-space5)'), variants.v3, 'var(--spacing-global-space5)'),
      m: _defineProperty(_defineProperty({}, variants.v2, 'var(--spacing-global-space6)'), variants.v3, 'var(--spacing-global-space3)'),
      l: _defineProperty(_defineProperty({}, variants.v2, 'var(--spacing-global-space7)'), variants.v3, 'var(--spacing-global-space5)')
    },
    padding: {
      xxs: _defineProperty(_defineProperty({}, variants.v2, 'var(--spacing-global-space5)'), variants.v3, 'var(--spacing-global-space3)'),
      m: _defineProperty(_defineProperty({}, variants.v2, {
        // Left and right keys below represent image positions. Padding values are the same regardless of image position for v2
        left: '0 var(--spacing-global-space9)',
        // 24px 48px
        right: '0 var(--spacing-global-space9)' // 24px 48px
      }), variants.v3, {
        // Left and right keys below represent image position. Padding left and right change based on image position for v3
        left: 'var(--spacing-global-space1) var(--spacing-global-space9) var(--spacing-global-space1) var(--spacing-global-space5)',
        // 2px 48px 2px 16px
        right: 'var(--spacing-global-space1) var(--spacing-global-space5) var(--spacing-global-space1) var(--spacing-global-space9)' // 2px 16px 2px 48px
      }),
      l: _defineProperty(_defineProperty({}, variants.v2, 'var(--spacing-global-space1) var(--spacing-global-space10)'), variants.v3, 'var(--spacing-global-space1) var(--spacing-global-space7) var(--spacing-global-space1) var(--spacing-global-space9)')
    }
  },
  imageHero: {
    backgroundColor: {
      brandLight: 'var(--color-brand-light)',
      // --color-very-pink100 or --color-littlewoods-purple100
      grey: 'var(--color-functional-panelMid)',
      // #FAFAFA
      white: 'var(--color-functional-panelLight)',
      // #000000
      whiteWithBorder: 'var(--color-functional-panelLight)' // #000000
    },
    border: {
      brandLight: 'none',
      grey: 'none',
      // #FAFAFA
      white: 'none',
      // #000000
      whiteWithBorder: 'var(--border-width-xs) solid var(--color-brand-mid)' // 1px solid --color-very-pink500 or --color-littlewoods-purple500
    }
  },
  imageWrapper: {
    width: {
      xxs: _defineProperty(_defineProperty({}, variants.v2, '100%'), variants.v3, '100%'),
      m: _defineProperty(_defineProperty({}, variants.v2, {
        '1:1': 'calc(311/720 * 100%)',
        // Width calculated based on figma design due to absent of ratio / percentage to container
        '4:3': 'calc(416/720 * 100%)' // Width calculated based on figma design due to absent of ratio / percentage to container
      }), variants.v3, 'calc(256/720 * 100%)'),
      l: _defineProperty(_defineProperty({}, variants.v2, {
        '1:1': 'calc(555/1280 * 100%)',
        // Width calculated based on figma design due to absent of ratio / percentage to container
        '4:3': 'calc(740/1280 * 100%)' // Width calculated based on figma design due to absent of ratio / percentage to container
      }), variants.v3, 'calc(334/1280 * 100%)')
    },
    alignItems: _defineProperty(_defineProperty({}, variants.v2, 'normal'), variants.v3, 'center'),
    displayMobile: _defineProperty(_defineProperty({}, variants.v2, 'block'), variants.v3, 'flex')
  }
};